var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "19", height: "19", viewBox: "0 0 19 19", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Phone"
    ),
    React.createElement("path", { d: "M7.38 6.156a1.683 1.683 0 0 0 0-2.378L5.597 1.993a1.683 1.683 0 0 0-2.38 0l-.977.979a2.519 2.519 0 0 0-.32 3.174 39.123 39.123 0 0 0 10.934 10.935c1 .66 2.329.528 3.176-.319l.978-.979a1.68 1.68 0 0 0 0-2.378l-1.784-1.784a1.68 1.68 0 0 0-2.38 0l-.594.594A39.871 39.871 0 0 1 6.786 6.75l.595-.594z", stroke: "#CBCEE0", strokeWidth: "1.3", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});


// WEBPACK FOOTER //
// ./src/ConnectedComponents/ConstituentCard/phone.svg